import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useWishlist } from '../utils/wishlist';
import OfferCard from '../components/common/OfferCard';

export default function SavedPage() {
  const navigate = useNavigate();
  const { items, savedIds, toggleSave } = useWishlist();

  return (
    <div className="App">
      <Helmet>
        <title>Saved Offers | OfferLelo</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <header className="modern-header">
        <div className="header-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <img src="/logo.svg" alt="OfferLelo Logo" />
          <span className="header-logo-text">OfferLelo</span>
        </div>
        <div className="header-actions">
          <button className="admin-btn" onClick={() => navigate('/')}>← Home</button>
        </div>
      </header>

      <div style={{ maxWidth: 1400, margin: '0 auto', padding: '24px 12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 4px 16px', flexWrap: 'wrap', gap: 8 }}>
          <h2 style={{ margin: 0, fontSize: '1.4rem', fontWeight: 800, color: '#1e293b' }}>
            ❤️ Saved Offers <span style={{ color: '#94a3b8', fontWeight: 600 }}>({items.length})</span>
          </h2>
        </div>

        {items.length === 0 ? (
          <div className="saved-empty">
            <div className="saved-empty-icon">🤍</div>
            <h3 className="saved-empty-title">No saved offers yet</h3>
            <p className="saved-empty-sub">
              Tap the heart on any offer to save it here for later.
            </p>
            <button onClick={() => navigate('/')} className="saved-empty-btn">
              Browse Offers →
            </button>
          </div>
        ) : (
          <div className="grid-container">
            {items.map(item => (
              <OfferCard
                key={item.id}
                item={item}
                savedIds={savedIds}
                onToggleSave={toggleSave}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
